import type { Shadows } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

const lightShadowsOverride: Shadows = [
  'none',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16)',
];

const darkShadowsOverride: Shadows = [
  'none',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  'rgba(0, 0, 0, 0.24) 0px 5px 22px 0px, rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
  '0px 0px 2px rgba(51, 51, 51, 0.48), 0px 4px 10px rgba(51, 51, 51, 0.16), rgba(255, 255, 255, 0.12) 0px 0px 0px 1px',
];

export default function createShadows(mode = 'light'): Shadows {
  const shadowsOverride = mode === 'light' ? lightShadowsOverride : darkShadowsOverride;
  return defaultTheme.shadows.map((shadow, index) => shadowsOverride[index] ?? shadow) as Shadows;
}
